import styled from "styled-components";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Header from "components/headers/light.js";
import SingleCol from "components/faqs/SingleCol";
import Footer from "components/footers/FiveColumnWithBackground";
import {useSelector} from "react-redux";
import {LangProvider} from "../lang";
import React from "react";


function Faq() {
    const locale = useSelector(state => state.locale);
    return (
        <LangProvider locale={locale}>
            <AnimationRevealPage>
                <Header />
                <SingleCol />
                <Footer />

            </AnimationRevealPage>
        </LangProvider>
    );
}

export default Faq;
